/**
 * Entitlement enums — single source of truth shared between the backend
 * (Prisma schema, Zod validators, repository, handlers) and the studio
 * frontend (locked/unlocked render decisions, purchase mutation kind).
 *
 * Mirrors the Prisma enums in `packages/database/prisma/schema.prisma`:
 *   `EntitlementKind`, `EntitlementStatus`, `EntitlementSource`.
 *
 * When you add a new value here, also add it to the Prisma enum + run the
 * migration. The Zod literal-array enums in
 * `apps/backend/src/domain/entitlement.models.ts` derive from these.
 */
export const ENTITLEMENT_KIND = {
    INVESTOR_MATCHES_UNLOCK: 'INVESTOR_MATCHES_UNLOCK',
};
export const ENTITLEMENT_STATUS = {
    PENDING_CHECKOUT: 'PENDING_CHECKOUT',
    ACTIVE: 'ACTIVE',
    REFUNDED: 'REFUNDED',
    REVOKED: 'REVOKED',
    EXPIRED: 'EXPIRED',
};
export const ENTITLEMENT_SOURCE = {
    PURCHASE: 'PURCHASE',
    ADMIN_GRANT: 'ADMIN_GRANT',
    OUTREACH_SETUP: 'OUTREACH_SETUP',
};
/**
 * String-literal arrays for the same values, useful when constructing Zod
 * `z.enum([...])` schemas in the backend.
 */
export const ENTITLEMENT_KIND_VALUES = ['INVESTOR_MATCHES_UNLOCK'];
export const ENTITLEMENT_STATUS_VALUES = [
    'PENDING_CHECKOUT',
    'ACTIVE',
    'REFUNDED',
    'REVOKED',
    'EXPIRED',
];
export const ENTITLEMENT_SOURCE_VALUES = ['PURCHASE', 'ADMIN_GRANT', 'OUTREACH_SETUP'];
//# sourceMappingURL=entitlements.js.map